// TSS vite/03 §"Query keys convention".
//
// A version is keyed by (plan, number) and not by number alone: two plans both
// have a version 1, and a single key would serve one plan's text under the
// other's name.

export const planKeys = {
    all:      ['plans'],
    list:     (params) => ['plans', 'list', params],
    detail:   (id)     => ['plans', 'detail', id],
    versions: (id, params) => ['plans', 'versions', id, params],
    version:  (id, number) => ['plans', 'version', id, String(number)],
};
